import { AppData, Log, Utils } from '@lightningjs/sdk'
import { KeyCodes } from '../lib/key-codes'
import { PlatformBase } from './platform-base'
import { Helper } from '../lib/helper'
import { PromiseResolver } from '../lib/components/grid/row-model'
import { AppSetup } from '../lib/app-setup'
import Router from '@lightningjs/sdk/src/Router'
import { Logger } from '../lib/logger'
import VideoScreenNew from '../pages/video-screen-new'
import { getSiteConfig, initSecurityToken } from '../lib/models/data-service'

export class PlatformVizio extends PlatformBase {
  libraryLoadPromise!: Promise<boolean[]>
  keyDownTimeStamp: any
  longpressId: any
  rejectFrequencyMs = 100
  longPressDelay = 1000
  lastKeyDownTimeStamp = Date.now()

  constructor() {
    super()
    this._setKeys()
    this.keyMap = {
      413: 'Stop',
      415: 'Play',
      19: 'Pause',
      412: 'Rewind',
      417: 'Forward',
      418: 'Next',
      419: 'Previous',
      461: 'Back',
      1313: 'LongEnter'
    }

    window.addEventListener('keyup', (e: KeyboardEvent) => {
      //console.log("KEY-HANDLER: key: up :" + e.key + ', keycode:' + e.keyCode + ', isComposing:' + e.isComposing);
      clearTimeout(this.longpressId);
      if (e.keyCode == 13) {
        e.preventDefault();
        e.stopPropagation();
        let curTime = new Date().getTime();
        let elapsed = curTime - this.keyDownTimeStamp;
        if (elapsed < this.longPressDelay) {
          let cEvent = new KeyboardEvent('keydown', { key: 'Enter', keyCode: 13, isComposing: false, repeat: true });
          this.currentKeyHandler(cEvent);
        }
      }
    }, {
      capture: true
    })

    window.addEventListener('keydown', (e: KeyboardEvent) => {
      // fix for IPTV-2091 - Vizio | Lightning | v2003 | unstable options menu upon hitting "0" button
      if (e.keyCode !== 13) {
        e.preventDefault();
        e.stopPropagation();
        if(app) {
          app._receiveKeydown(e)
        }
        return false;
      } 

      // this section handles the trottling of key repeatation 
      let currTimestamp = Date.now();
      if (currTimestamp - this.lastKeyDownTimeStamp < this.rejectFrequencyMs
        || e.keyCode == 204 //vizio specific key not to handle
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      this.lastKeyDownTimeStamp = currTimestamp

      // this section handles the trottling of key repeatation 
      if (e.keyCode == 13) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!e.repeat) {
          //console.log("KEY-HANDLER: key: down : repeat: " + e.repeat + ", key: " + e.key + ', keycode:' + e.keyCode + ', isComposing:' + e.isComposing + ', refect: ' + (currTimestamp - this.lastKeyDownTimeStamp));
          this.keyDownTimeStamp = new Date().getTime();
          clearTimeout(this.longpressId);
          this.longpressId = setTimeout(() => {
            let curTime = new Date().getTime();
            let elapsed = curTime - this.keyDownTimeStamp;
            let cEvent = new KeyboardEvent('keydown', { key: 'LongEnter', keyCode: 1313, isComposing: false });
            this.currentKeyHandler(cEvent);
          }, this.longPressDelay);
        }
      }
    }, {
      capture: true
    })

    //this._loadLibrary()
  }

  // _loadLibrary() {
  //   this.libraryLoadPromise = Helper.getScripts([
  //     'http://localhost:12345/scfs/cl/js/vizio-companion-lib.js'
  //   ])
  // }

  currentKeyHandler(e) {
    if (app) {
      Log.info("KEY-HANDLER currentKeyHandler: key: " + e.key + ', keycode:' + e.keyCode + ', isComposing:' + e.isComposing);
      let focusPath = app.__getFocusPath()
      app.application._receiveKeydown(e)
      // if (e.keyCode == 1313) {
      //   window.dispatchEvent(e)
      // } else {
      //   let fn = e.keyCode == 1313 ? '_handleKey' : '_handleEnter'
      //   focusPath.reverse()
      //   let handleChild = focusPath.filter(el => el._hasMethod(fn) === true)[0]
      //   if (handleChild) {
      //     handleChild[fn](e)
      //   }
      // }
    }
  }

  override setKeyMappings(appSettings: any) {
    appSettings.keys = this.keyMap
    return this.keyMap
  }

  override _setKeys() {
    KeyCodes.KEY_STOP = 413;
    KeyCodes.KEY_PLAY = 415;
    KeyCodes.KEY_PAUSE = 19;
    KeyCodes.KEY_REWIND = 412;
    KeyCodes.KEY_FORWARD = 417;
    KeyCodes.KEY_EXIT = 27;
    KeyCodes.KEY_NEXT = 418;
    KeyCodes.KEY_PREVIOUS = 419;
  }

  override remapSiteId(siteId: string): string {
    return siteId == '236' ? '1285' : siteId
  }

  override async initialize(): Promise<boolean> {
    this._shouldShowExitPopup = true
    const { appState, appConfig } = AppData as AppSetup
    appConfig.enableContextualBackspace = true
    const app = appState?.getApp()!
    if (app.siteId == '236') {
      appConfig.siteId = '1285'
      app.siteId = '1285'
    }
    appConfig.nonClickableBugAds = true
    appConfig.enableSimpleAgeRatingDialog = true
    appConfig.enableOnlyURLDisplay = true       // For displaying only URL in Privacy Policy and Terms & Conditions of setting screen in Vizio
    this._siteConfig = await getSiteConfig()
    Log.info('PlatformBase: siteConfig: ', this._siteConfig)
    Helper.getSiteConfigInfo(this._siteConfig)

    if(appConfig.enableSecurityToken){
      appConfig?.apiVersion = "sv9.0";
      var securityToken = Helper.getCookie("_token");
      if (securityToken) {
        appConfig.securityToken = securityToken;
      } else {
        var securityTokenAPIResp = await initSecurityToken();
        appConfig.securityToken = securityTokenAPIResp.securityToken;
        Helper.setGeneralCookie("_token", appConfig.securityToken, 1);
      }
    }

    document.addEventListener("visibilitychange", (event) => {
      Log.info('visibilitychange: ', document.hidden)
      if (document.hidden) {
        const { appConfig, appState } = AppData as AppSetup;
        appState.appUnload = true
        const route = Router.getActiveRoute()!
        if (route.indexOf('video') > -1) {
          const page: VideoScreenNew = Router.getActivePage()
          page.hitCloseTracker()
          page.closeVideo(true)
        }
        Logger.processUserAction('userExitedViaRemoteDirectly', 'App unloaded')
      }
      //console.log("APP: BEFORE UNLOAD APP");
    });

    const results:boolean = await new Promise((resolve, reject) => {

      Log.info('PlatformBase:', typeof this, window.VIZIO)



      if(window.VIZIO) {
        let isLoaded =false
        let timeIntv = null
        document.addEventListener("VIZIO_LIBRARY_DID_LOAD", () => {
          Log.info('PlatformBase: VIZIO_LIBRARY_DID_LOAD')
          isLoaded = true
          clearTimeout(timeIntv)
          const promiseArry = []
          promiseArry.push(this._getDeviceId())
          promiseArry.push(this._getDeviceAdId())
          promiseArry.push(this._getVizioDeviceModel())
          promiseArry.push(this._getVizioFirmware())
          this._setClosedCaptionHandler()
          Promise.all(promiseArry).then(data =>{ 
            resolve(true)
          })
        })

        timeIntv = setTimeout(()=>{
          if(!isLoaded) {
            document.dispatchEvent(new Event('VIZIO_LIBRARY_DID_LOAD'))
          }
        }, 2000)
        
      } else {
        Log.info('PlatformBase: scriptLoading status failed')
        resolve(true)
      }
    })

    return results
  }

  override sendMetrics(eventType: string, dataObj: any) {
    Log.info('Send Metrics:', eventType, dataObj)
    switch (eventType) {
      case 'close':
        if (window.VIZIO) {
          VIZIO.exitApplication()
        }
        break;
    }
  }

  override getPlatformDeeplinkData(contentChangeUrl?: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!contentChangeUrl) {
        contentChangeUrl = location.search
      }
      const playId = Helper.getIptvParameterFromUrl('playId', contentChangeUrl);
      const searchKeys = Helper.getIptvParameterFromUrl('searchKeys', contentChangeUrl);

      let deeplinks: any = {}

      if (playId !== undefined && playId !== '') {
        deeplinks.sourceType = 'hs-d';
        deeplinks.playId = playId;
        resolve(`?playId=${deeplinks.playId}&src=${deeplinks.sourceType}`)
      } else if (searchKeys !== undefined && searchKeys !== '') {
        deeplinks.sourceType = 'hs-search';
        deeplinks.playId = playId;
        resolve(`?${contentChangeUrl?.split('?')[1]}`)
      } else {
        resolve('')
      }
    })
  }

  _setClosedCaptionHandler() {
    if (window.VIZIO) {
      window.VIZIO.setClosedCaptionHandler((isCCEnabled: boolean) => {
        this._updateCCVisibility(isCCEnabled)
      });
    }
  }

  _updateCCVisibility(isCCEnabled:boolean) {
    const route = Router.getActiveRoute()!
    const { appState } = AppData as AppSetup
    appState.showSubtitle = isCCEnabled
    if (route.indexOf('video') > -1) {
      const page: VideoScreenNew = Router.getActivePage()
      page.showHideSubtitleState(isCCEnabled)
    }
    if (isCCEnabled) {
      Log.info('closed captioning enabled');
    } else {
      Log.info('closed captioning disabled');
    }
  }

  _getVizioDeviceModel() {
    return new Promise(resolve => {
      if (window.VIZIO !== undefined) {
        this._fullModel = window.VIZIO.deviceModel
      }
      return resolve(true);
    })

  }

  _getVizioFirmware() {
    return new Promise(resolve => {
      if (window.VIZIO !== undefined) {
        window.VIZIO.getFirmwareVersion((firmwareVersion) => {
          this._firmwareVersion = firmwareVersion
          resolve(true);
        });
      } else {
        resolve(true)
      }
    })
  }

  _getDeviceAdId(): Promise<boolean> {
    return new Promise(resolve => {

      Log.info("getVizioDeviceAdId() called");
      if (window.VIZIO !== undefined) {
        try {
          window.VIZIO.setAdvertiserIDListener((adidJson: any) => {

            const ifaObj = { ifa: '', ifa_type: '', lmt: '0' }
            ifaObj.ifa = adidJson.IFA;
            ifaObj.ifa_type = adidJson.IFA_TYPE;
            //appConfig.limitAdTracking = adidJson.LMT;

            if (adidJson.LMT == true || adidJson.LMT == 1) {
              ifaObj.lmt = '1';
            } else {
              ifaObj.lmt = '0';
            }

            this.setIFADetails(ifaObj)

            Log.info("Advertising Id: " + ifaObj.ifa);
            Log.info("Advertising Id Type: " + ifaObj.ifa_type);
            Log.info("Advertising LimitAdTracking: " + ifaObj.lmt);
            resolve(true)
          });
        } catch (e) {
          Log.info("Advertising Id method failed");
          resolve(true)
          //appConfig.currentDeviceId = '';
        }
      }
    })
  }

  _getDeviceId(): Promise<boolean> {
    return new Promise((resolve) => {
      Log.info("getVizioDeviceId() called");
      if (window.VIZIO !== undefined) {
        try {
          window.VIZIO.getDeviceId((userDeviceId) => {
            Log.info("Device Id: " + userDeviceId);
            this._deviceId = userDeviceId;
            resolve(true)
          });
        } catch (e) {
          resolve(true)
        }
      }
    })
  }

  override getAppStoreId(type = ''): string {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    if (appApiConfig && appApiConfig.appConfig.vizioAppId) {
      return appApiConfig.appConfig.vizioAppId
    }
    return ''
  }

  override textToSpeach(str) {
    if (str === undefined || str === '') return
    let string = Helper.normalizeForChromeVox(str)
    Log.info('VoiceTTS: ', string);
    if (window.VIZIO !== undefined) {
      if (window.VIZIO.Chromevox !== undefined) {
        //window.VIZIO.Chromevox.cancel() ;
        window.VIZIO.Chromevox.play(string); //play the string passed
      }
    }
  }

  override getOptionsIconPath(apiOptionsIcon: string | undefined) {
    if (apiOptionsIcon && apiOptionsIcon !== '') {
      return apiOptionsIcon
    }
    return Utils.asset('/images/option_0.png')
  }

  override getMake(): string {
    if (window.VIZIO !== undefined) {
      if (window.VIZIO.deviceInfo && window.VIZIO.deviceInfo && window.VIZIO.deviceInfo.modelSeries) {
        return window.VIZIO.deviceInfo.modelSeries;
      }
    }
    return ''
  }

  override isOptionsKey(e: KeyboardEvent): boolean {
    if (e.code == 'Digit0') {
      return true
    }
    return false
  }

  override getOptionsText() {
    return 'Press 0 | Long Press OK\nfor Options'
  }

  override getScript(platformSettings): string[] {
    return [
      'http://localhost:12345/scfs/cl/js/vizio-companion-lib.js',
      'https://code.jquery.com/jquery-3.7.0.min.js',
      platformSettings.path + 'modules/hlsjs/hls.min.js',
      platformSettings.path + 'modules/dashjs/dash.all.min.js',
      'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
    ]
  }

  //Ad Macros related value mapping functions based on the platform.

  override getAppNameMacro(appName: string, siteId?: string, removeSpace:boolean = false): string {
    let videoAppName = this.VizioAppNameMap.find((item) => item[0].toLowerCase() === siteId)
    let returnVal:string = appName
    if(videoAppName) {
      returnVal = videoAppName[2] || '';
    }
    return Helper.capitalizeFirstLetter(returnVal,removeSpace)
  }

  override getAppStoreUrlMacro(appName: string, siteId?:string): string {
    const name = this.getAppNameMacro(appName, siteId, true)
    const appId = name.toLowerCase()
    return encodeURI(`https://www.vizio.com/en/smart-tv-apps?appname=${name}&appId=vizio.${appId}`)
  }

  override getRatingMacro(rating: string): string {
    if(!rating || rating.length === 0) {
      return ''
    }
    const vizioRating = this.VizioRatingMap.find((item) => item[0].toLowerCase() === rating.toLowerCase())
    return vizioRating ? vizioRating[1] : rating

  }

  override getGenreMacro(genres: string): string {
    if (!genres || genres.length === 0) {
      return ''
    }
    const vizioGenres: string[] = []
    genres.split(',').map((genre) => {
      const genreMap = this.VizioGenreMap.find((item) => item[0].toLowerCase() === genre.toLowerCase())
      if (genreMap) {
        if (!vizioGenres.includes(genreMap[1])) {
          vizioGenres.push(genreMap[1])
        }
      }
      //  else {
      //   vizioGenres.push(genre)
      // }
    })
    return vizioGenres.join(',')
  }

  VizioAppNameMap: string[][] = [ 
    ['1171', 'maverickfreeblackcinema', 'maverick black cinema'],
    ['946', 'filmrisekids', 'filmrise kids'],
    ['948', 'filmrisedocumentary', 'filmrise documentary'],
    ['958', 'filmriseforher', 'filmrise for her'],
    ['1120', 'legoChannel', 'lego-tv'],
    ['1285', 'fawefiretv', 'fawesome'],
  ]

  // vizio rating mapping array.
  VizioRatingMap: string[][] = [
    // movie rating mapping array. was also compared with the 
    //following link: https://en.wikipedia.org/wiki/Motion_Picture_Association_film_rating_system

    // "M"-rated films were suitable for children,"M" was renamed to "GP" (for General audiences,
    // Parental guidance suggested),[22][23] and in 1971, the MPAA added the content advisory 
    // "Some material not generally suitable for pre-teenagers" On February 11, 1972 "GP" was revised to "PG".
    
    // In 1970, the ages for "R" and "X" were raised from 16 to 17.[21] Also, due to confusion over whether
    
    ['G', 'G'], //General audiences – All ages admitted.    
    ['All Ages', 'G'], //General audiences – All ages admitted.
    ['M', 'PG'], //Suggested for mature audiences - Parental discretion advised.
    ['GP', 'PG'], //All ages admitted – Parental guidance suggested.
    ['PG', 'PG'], //Parental Guidance Suggested
    ['7+', 'PG-13'], //Parents Strongly Cautioned
    ['PG-13', 'PG-13'], //Parents Strongly Cautioned
    ['13+', 'PG-13'], // Restricted. Under 17 requires accompanying parent or adult guardian
    ['14+', 'PG-13'], // Restricted. Under 17 requires accompanying parent or adult guardian
    ['16+', 'R'], // Restricted. Under 17 requires accompanying parent or adult guardian
    ['R', 'R'], // Restricted. Under 17 requires accompanying parent or adult guardian
    ['NR', 'NC-17'], // No One 17 and Under Admitted.
    ['X', 'NC-17'],
    ['18+', 'NC-17'],
    ['NC-17', 'NC-17'],
    // vizio tv rating mapping array.
    ['TV-Y', 'TV-Y'],
    ['TV-Y7 FV', 'TV-Y FV'],
    ['TV-G', 'TV-G'],
    ['TV-PG', 'TV-PG'],
    ['TV-14', 'TV-14'],
    ['TV-MA', 'TV-MA']    
  ]

  // vizio genera mapping array.
  VizioGenreMap: string[][] = [
    ['Action - Comic', 'Action'],
    ['Action Comedy', 'Action'],
    ['Action Crime', 'Action'],
    ['Action Films by Fawesome.tv', 'Action'],
    ['Action', 'Action'],
    ['Affirmative Action', 'Action'],
    ['Epic Action', 'Action'],
    ['Filmrise Action Channel', 'Action'],
    ['Futuristic Action', 'Action'],
    ['Hindi Action Films', 'Action'],
    ['Hindi Action Films', 'Action'],
    ['Hindi Action', 'Action'],
    ['Martial Art', 'Action'],
    ['Adventure Climbing', 'Adventure'],
    ['Adventure Films by Fawesome.tv', 'Adventure'],
    ['Adventure', 'Adventure'],
    ['Adventure Scouts', 'Adventure'],
    ['Adventure Sports', 'Adventure'],
    ['Adventure Swimming', 'Adventure'],
    ['Adventure Trails', 'Adventure'],
    ['Adventure Travel', 'Adventure'],
    ['Adventure Travel', 'Adventure'],
    ['Adventure-Comic', 'Adventure'],
    ['Family Adventure', 'Adventure'],
    ['Hindi Adventure', 'Adventure'],
    ['Romantic Adventure', 'Adventure'],
    ['Animated', 'Animation'],
    ['Anime', 'Anime'],
    ['Filmrise Anime TV', 'Anime'],
    ['Anthology', 'Anthology'],
    ['Arts', 'Arts'],
    ['Auto', 'Automative'],
    ['Crafts', 'Arts'],
    ['Motor Racing', 'Automative'],
    ['Biography', 'Biography'],
    ['Happykids.tv', 'Kids'],
    ['British Comedy', 'Comedy'],
    ['Cat Comedy', 'Comedy'],
    ['Celebrity Comedy', 'Comedy'],
    ['Chic Comedy', 'Comedy'],
    ['City Comedy', 'Comedy'],
    ['Comedy', 'Comedy'],
    ['Comedy Artists', 'Comedy'],
    ['Comedy Cartoon', 'Comedy'],
    ['Comedy Cultural', 'Comedy'],
    ['Comedy Documentary', 'Comedy'],
    ['Comedy', 'Comedy'],
    ['Comedy History', 'Comedy'],
    ['Comedy Kids', 'Comedy'],
    ['Comedy Nights With Kapil', 'Comedy'],
    ['Comedy Series', 'Comedy'],
    ['Comedy Sketch', 'Comedy'],
    ['Comedy Songs', 'Comedy'],
    ['Comedy Theme', 'Comedy'],
    ['Country Comedy', 'Comedy'],
    ['Dating Comedy', 'Comedy'],
    ['Dirty Comedy', 'Comedy'],
    ['Doctor Comedy', 'Comedy'],
    ['Documentary Comedy', 'Comedy'],
    ['Dog Comedy', 'Comedy'],
    ['Drunk And Disorderly Comedy', 'Comedy'],
    ['Family Life Comedy', 'Comedy'],
    ['Farce/Slapstick', 'Comedy'],
    ['Flirty Comedy', 'Comedy'],
    ['Food Comedy', 'Comedy'],
    ['Gay Comedy', 'Comedy'],
    ['Ghetto Comedy', 'Comedy'],
    ['God Comedy', 'Comedy'],
    ['Growing-up Comedy', 'Comedy'],
    ['Hindi Comedy', 'Comedy'],
    ['Horror Comedy', 'Comedy'],
    ['IComedy', 'Comedy'],
    ['IComedy', 'Comedy'],
    ['Jewish Comedy', 'Comedy'],
    ['Lawyer Comedy', 'Comedy'],
    ['Lesbian Comedy', 'Comedy'],
    ['Marriage Comedy', 'Comedy'],
    ['Men-Women Comedy', 'Comedy'],
    ['Military Comedy', 'Comedy'],
    ['Money Comedy', 'Comedy'],
    ['Nationality Comedy', 'Comedy'],
    ['Nationality Comedy', 'Comedy'],
    ['Neighborhood Comedy', 'Comedy'],
    ['Nurse Comedy', 'Comedy'],
    ['Parenthood Comedy', 'Comedy'],
    ['Partying Comedy', 'Comedy'],
    ['Pick Up Comedy', 'Comedy'],
    ['Police Comedy', 'Comedy'],
    ['Politics Comedy', 'Comedy'],
    ['Pregnancy Comedy', 'Comedy'],
    ['Psychological Comedy', 'Comedy'],
    ['Racial Stereotype Comedy', 'Comedy'],
    ['Raunchy Comedy', 'Comedy'],
    ['Relationships Comedy', 'Comedy'],
    ['Religion Comedy', 'Comedy'],
    ['Sardar Comedy', 'Comedy'],
    ['Satire', 'Comedy'],
    ['School Comedy', 'Comedy'],
    ['Science Fiction Comedy', 'Comedy'],
    ['Screwball Comedy', 'Comedy'],
    ['Sex Comedy', 'Comedy'],
    ['Social Situation Comedy', 'Comedy'],
    ['Sport Comedy', 'Comedy'],
    ['Technology Comedy', 'Comedy'],
    ['Travel Comedy', 'Comedy'],
    ['Work Comedy', 'Comedy'],
    ['Cooking', 'Cooking'],
    ['Easy Cooking', 'Cooking'],
    ['IFTV Channel', 'Cooking'],
    ['Organic Cooking', 'Cooking'],
    ['Courtroom', 'Crime'],
    ['Crime Comedy', 'Crime'],
    ['Crime Drama', 'Crime'],
    ['Crime Films by Fawesome', 'Crime'],
    ['Crime', 'Crime'],
    ['Crime Investigation', 'Crime'],
    ['Crime Scene', 'Crime'],
    ['Crime Secrets', 'Crime'],
    ['Cyber Crime', 'Crime'],
    ['Detective', 'Crime'],
    ['Filmrise True Crime Channel', 'Crime'],
    ['Gangster', 'Crime'],
    ['Hard Boiled', 'Crime'],
    ['Heist', 'Crime'],
    ['Hindi Crime Films', 'Crime'],
    ['Horror-Crime', 'Crime'],
    ['Mystery-Crime', 'Crime'],
    ['Neo-Noir', 'Crime'],
    ['Police Drama/Law Enforcement', 'Crime'],
    ['True Crime', 'Crime'],
    ['Dance', 'Cuisine'],
    ['Dance', 'Cuisine'],
    ['Dark Comedy', 'Cuisine'],
    ['Debate', 'Cuisine'],
    ['Scuba Diving', 'Cuisine'],
    ['Skydiving', 'Cuisine'],
    ['Documentary Comedy', 'Documentary'],
    ['Documentary Films by Fawesome.tv', 'Documentary'],
    ['Documentary', 'Documentary'],
    ['Dog Sledding', 'Documentary'],
    ['Hindi Documentary', 'Documentary'],
    ['Urban Documentary', 'Documentary'],
    ['Drama - Religious', 'Drama'],
    ['Drama Films by Fawesome.tv', 'Drama'],
    ['Drama', 'Drama'],
    ['Drama-Cultural', 'Drama'],
    ['Family Life Drama', 'Drama'],
    ['Hindi Drama Films', 'Drama'],
    ['Marital Drama', 'Drama'],
    ['Melodrama', 'Drama'],
    ['Police Drama/Law Enforcement', 'Drama'],
    ['Political Drama', 'Drama'],
    ['Political Drama', 'Drama'],
    ['Psychological Drama', 'Drama'],
    ['Psychological Drama', 'Drama'],
    ['Romantic Drama', 'Drama'],
    ['Western Drama', 'Drama'],
    ['Western Drama', 'Drama'],
    ['Entertainment', 'Entertaining'],
    ['Events', 'Entertaining'],
    ['Crisis of Faith', 'Faith-Based'],
    ['Faith', 'Faith-Based'],
    ['Faith Shows', 'Faith-Based'],
    ['Hindi Family Films', 'Family'],
    ['Fantasy', 'Fantasy'],
    ['Fiction and Fantasy Films by Fawesome.tv', 'Fantasy'],
    ['Hindi Fantasy Films', 'Fantasy'],
    ['Style', 'Fashion'],
    ['Ballet Fit', 'Fitness'],
    ['Body Building', 'Fitness'],
    ['Food', 'Food'],
    ['IFTV Channel', 'Food'],
    ['GameSmart.tv', 'Game Show'],
    ['Horror Game Series', 'Game Show'],
    ['Murder Mystery Games', 'Game Show'],
    ['Virtual Reality Games', 'Game Show'],
    ['Golf', 'Sports'],
    ['LGBT', 'LGBTQ+'],
    ['LGBTQ', 'LGBTQ+'],
    ['LGBTQ+', 'LGBTQ+'],
    ['DiabeticLiving', 'Health'],
    ['Environmental Health', 'Health'],
    ['Exercise', 'Health'],
    ['Health', 'Health'],
    ['HealthSmart', 'Health'],
    ['Alternate History', 'History'],
    ['Ancient History - keyword', 'History'],
    ['Auto History', 'History'],
    ['Comedy History', 'History'],
    ['Family History', 'History'],
    ['Food History', 'History'],
    ['Hindi History Films', 'History'],
    ['History', 'History'],
    ['Hockey', 'History'],
    ['Period', 'History'],
    ['Prehistoric', 'History'],
    ['Holiday', 'Holiday'],
    ['Holidays', 'Holiday'],
    ['Home Improvement', 'Home'],
    ['Home Remodelling', 'Home'],
    ['Remodelling', 'Home'],
    ['Room Remodelling', 'Home'],
    ['Apocalyptic Horror', 'Horror'],
    ['Filmrise Horror Channel', 'Horror'],
    ['Found Footage Horror', 'Horror'],
    ['Gardening', 'Gardening'],
    ['Hindi Horror Films', 'Horror'],
    ['Home by Fawesome.tv', 'Horror'],
    ['Horror Films by Fawesome.tv', 'Horror'],
    ['Horror', 'Horror'],
    ['Horse Riding', 'Horror'],
    ['How to', 'DIY'],
    ['Killer Doll Horror Films', 'Horror'],
    ['Monster Horror', 'Horror'],
    ['Psychological Horror', 'Horror'],
    ['Slasher Horror', 'Horror'],
    ['Splatter Horror', 'Horror'],
    ['Supernatural Horror', 'Horror'],
    ['Survival Horror', 'Horror'],
    ['WatchFreeHorrorFlix', 'Horror'],
    ['Hunting', 'Hunting'],
    ['Educational', 'Instructional'],
    ['Ieducation.tv', 'Instructional'],
    ['Interview', 'Interview'],
    ['Kayaking', 'Interview'],
    ['Alphabet Rhymes', 'Kids'],
    ['Animal Rhymes', 'Kids'],
    ['Bugs Rhymes', 'Kids'],
    ['Classic Rhymes', 'Kids'],
    ['Forest Rhymes', 'Kids'],
    ['Fruit Rhymes', 'Kids'],
    ['Kid Rhymes', 'Kids'],
    ['Kids Educational Songs', 'Kids'],
    ['Kids Edutainment', 'Kids'],
    ['Kids', 'Kids'],
    ['Kids Learning', 'Kids'],
    ['Kids Songs', 'Kids'],
    ['Lacrosse', 'Kids'],
    ['Learning About Fruits', 'Kids'],
    ['Learning About Vegetables', 'Kids'],
    ['Number Rhymes', 'Kids'],
    ['Transportation Rhymes', 'Kids'],
    ['Vegetable Rhymes', 'Kids'],
    ['Water Rhymes', 'Kids'],
    ['Business', 'Lifestyle'],
    ['Martial Art', 'Martial Arts'],
    ['MMA', 'Martial Arts'],
    ['Military', 'Military'],
    ['Miniseries', 'Military'],
    ['MMA', 'Military'],
    ['Bollywood Songs', 'Music'],
    ['British Music', 'Music'],
    ['Children', 'Kids'],
    ['Children Music', 'Music'],
    ['Latin Music', 'Music'],
    ['Music', 'Music'],
    ['Music By Fawesome', 'Music'],
    ['Music Icon', 'Music'],
    ['Music Legend', 'Music'],
    ['Musician', 'Music'],
    ['Hindi Musical Films', 'Musical'],
    ['Musical', 'Musical'],
    ['Hindi Mystery Films', 'Mystery'],
    ['Murder Mystery', 'Mystery'],
    ['Mystery Films by Fawesome', 'Mystery'],
    ['Mystery', 'Mystery'],
    ['Mystery Minis', 'Mystery'],
    ['Psychological Mystery', 'Mystery'],
    ['Real Life Mystery', 'Mystery'],
    ['Romantic Mystery', 'Mystery'],
    ['Suspense', 'Mystery'],
    ['Animal', 'Nature'],
    ['Aquatic Animals', 'Nature'],
    ['Arctic Animals', 'Nature'],
    ['Desert Animals', 'Nature'],
    ['Domestic Animals', 'Nature'],
    ['Farm Animals', 'Nature'],
    ['Grassland Animals', 'Nature'],
    ['Nature', 'Nature'],
    ['Nature', 'Nature'],
    ['Nature Travel', 'Nature'],
    ['Prehistoric Animals', 'Nature'],
    ['Wild Animals', 'Nature'],
    ['Environmental News', 'News'],
    ['News', 'News'],
    ['Olympics', 'News'],
    ['Opera', 'News'],
    ['Ultimate Outdoors Show', 'News'],
    ['Weather', 'News'],
    ['Paranormal', 'Paranormal'],
    ['Parenting', 'Paranormal'],
    ['Performance Arts', 'Performing Arts'],
    ['Pool', 'Politics'],
    ['Reality', 'Reality'],
    ['Reality-TV', 'Reality'],
    ['Faith', 'Religion'],
    ['Bromance', 'Romance'],
    ['Hindi Romantic Films', 'Romance'],
    ['Hopeless Romantic', 'Romance'],
    ['Lawyer-Client Romance', 'Romance'],
    ['Relationship', 'Romance'],
    ['Relationship Advice', 'Romance'],
    ['Romance', 'Romance'],
    ['Romantic Comedy', 'Romance'],
    ['Rugby', 'Romance'],
    ['Running', 'Romance'],
    ['Sailing', 'Romance'],
    ['Alien Encounter', 'Science'],
    ['Biopunk', 'Science'],
    ['Computers', 'Science'],
    ['Cyberpunk', 'Science'],
    ['Environmental Science', 'Science'],
    ['Forensic Science', 'Science'],
    ['Hard Sci-Fi', 'Science'],
    ['Punk Sci-Fi', 'Science'],
    ['Science', 'Science'],
    ['Science Fiction', 'Science'],
    ['Space Opera', 'Science'],
    ['Speculative Sci-fi', 'Science'],
    ['Survival Sci-Fi', 'Science'],
    ['Technology', 'Science'],
    ['Action-Sci Fi', 'Science-Fiction'],
    ['Apocalyptic Sci-Fi', 'Science-Fiction'],
    ['Shopping', 'Variety'],
    ['Sitcom', 'Sitcom'],
    ['Skateboarding', 'Sitcom'],
    ['Awards', 'Sketch'],
    ['Skiing', 'Sketch'],
    ['Soccer', 'Sketch'],
    ['Adventure Sports', 'Sports'],
    ['Adventure Swimming', 'Sports'],
    ['Archery', 'Sports'],
    ['Badminton', 'Sports'],
    ['Baseball', 'Sports'],
    ['Basketball', 'Sports'],
    ['Bicycling', 'Sports'],
    ['Billiards', 'Sports'],
    ['Bobsledding', 'Sports'],
    ['Bowling', 'Sports'],
    ['Boxing', 'Sports'],
    ['Canoe', 'Sports'],
    ['Card Games', 'Sports'],
    ['Cheerleading', 'Sports'],
    ['Combat Sports', 'Sports'],
    ['Cricket', 'Sports'],
    ['Fantasy Motor Sports', 'Sports'],
    ['Fencing', 'Sports'],
    ['Fishing', 'Sports'],
    ['Football', 'Sports'],
    ['Gymnastics', 'Sports'],
    ['Motor Sports', 'Sports'],
    ['Mud Wrestling', 'Sports'],
    ['Sports', 'Sports'],
    ['Sports By Fawesome', 'Sports'],
    ['Sports Comedy', 'Sports'],
    ['Standup Comedy', 'Sports'],
    ['Surface Water Sports', 'Sports'],
    ['Surface Water Sports', 'Sports'],
    ['Surfing', 'Sports'],
    ['Surfing', 'Sports'],
    ['Swimming', 'Sports'],
    ['War Veteran', 'Sports'],
    ['Water Sports', 'Sports'],
    ['Web-Based Fantasy Sports', 'Sports'],
    ['Winter Sports', 'Sports'],
    ['Talk Show', 'Talk Show'],
    ['Tennis', 'Sports'],
    ['Apocalyptic Thriller', 'Thriller'],
    ['Hindi Thriller Films', 'Thriller'],
    ['Political Thriller', 'Thriller'],
    ['Psychological Thriller', 'Thriller'],
    ['Survival Thriller', 'Thriller'],
    ['Thriller', 'Thriller'],
    ['Road', 'Travel'],
    ['Road Trip', 'Travel'],
    ['Travel', 'Travel'],
    ['Travel Keyword', 'Travel'],
    ['Bosnian War', 'War'],
    ['Chemical Warfare', 'War'],
    ['Civil War', 'War'],
    ['Cold War Era', 'War'],
    ['Iraq War', 'War'],
    ['Psychological War', 'War'],
    ['Vietnam War', 'War'],
    ['War', 'War'],
    ['Warfare', 'War'],
    ['Worl War II', 'War'],
    ['World War I', 'War'],
    ['World War III', 'War'],
    ['Modern Western', 'Western'],
    ['Mud Wrestling', 'Western'],
    ['Western', 'Western'],
    ['Western', 'Western'],
    ['Religious', 'Religion']
  ]
}
